module.exports = __webpack_public_path__ + "img/gray-explain-in-detail.32e9a08a.png";